export const Identifier = {
  print: ({ node }) => node.name
};
